import { render } from "./menuDesktop.vue?vue&type=template&id=1f4b036a&scoped=true"
import script from "./menuDesktop.vue?vue&type=script&lang=js"
export * from "./menuDesktop.vue?vue&type=script&lang=js"

import "./menuDesktop.vue?vue&type=style&index=0&id=1f4b036a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4b036a"]])

export default __exports__